import { getCdnBaseUrl, getCdnVersion } from './cdn-util'

export const assetUrl = ({
  pathPrefix,
  filename,
  developmentPathPrefix,
  namespace = 'standalone',
}: {
  pathPrefix: string
  filename: string
  developmentPathPrefix?: string
  namespace?: string
}) => {
  let assetPath = developmentPathPrefix ?? `/assets/${pathPrefix}/${filename}`
  let basePath = ``

  // When deployed, use the cdn as the base path for assets.
  if (process.env['NODE_ENV'] === 'production') {
    assetPath = `/assets/${pathPrefix}/${filename}`
    basePath = `${getCdnBaseUrl()}/web/${namespace}/${getCdnVersion()}`
  }

  return `${basePath}${assetPath}`
}
